<template>
    <section>
        <m-table-list ref="tableList" :fetch-list-func="fetchListFunc" :search-form.sync="filters">
            <template v-slot:search-items>
                <m-search-panel @searchBoxChange="handleSearch" isShowOpenButton @keyup.enter.native="handleSearch()">
                    <div slot="title">快速筛选</div>
                    <div class="filters">
                        <div class="query-item-all">
                            <div class="filter-item">
                                <div class="demonstration">账号查询</div>
                                <el-input v-model="filters.account" placeholder="账号"></el-input>
                            </div>
                            <div class="filter-item">
                                <div class="demonstration">启用状态</div>
                                <el-select v-model="filters.status" placeholder="不限" clearable>
                                    <el-option value="Enable" label="启用" />
                                    <el-option value="Disable" label="禁用" />
                                </el-select>
                            </div>
                            <div class="filter-item">
                                <div class="demonstration">真实姓名</div>
                                <el-input v-model="filters.realName" placeholder="真实姓名"></el-input>
                            </div>

                            <div class="filter-item">
                                <div class="demonstration">角色</div>
                                <el-select v-model="filters.id" placeholder="选择角色" clearable @change="handleChange">
                                    <el-option v-for="item in roleOptions" :key="item.id" :value="item.id" :label="item.roleName" />
                                </el-select>
                                <!--                <el-input v-model="filters.roleName" placeholder="角色"></el-input>-->
                            </div>

                            <div class="filter-item">
                                <div class="demonstration">电话</div>
                                <el-input v-model="filters.phone" placeholder="电话"></el-input>
                            </div>

                        </div>
                        <div class="filter-item buttons">
                            <!-- <el-button class="reset-btn" @click="$router.push({name: 'privilege.menu.details'})">新建</el-button> -->
                            <el-button type="primary" size="samll" class="query-btn" @click="handleSearch">查询</el-button>
                            <el-button type="primary" size="samll" plain @click="handleClearSearchForm">重置</el-button>
                        </div>
                    </div>
                </m-search-panel>
            </template>
            <template v-slot:page-title>
                <div class="page-tabe-title">
                    <div class="right">
                        <span class="line"></span>
                        <div>数据列表</div>
                    </div>
                    <div class="left">
                        <el-button type="primary" size="small" :loading="syncIng" @click="handleSync">刷新信息</el-button>
                    </div>
                </div>
            </template>
            <template v-slot:table-columns>
                <el-table-column label="账号" prop="account"></el-table-column>
                <el-table-column label="真实姓名" prop="realName"></el-table-column>
                <el-table-column label="角色" prop="roleName" align="center">
                    <template slot-scope="{row}">
                        {{ row.roleName && row.roleName.length > 0 ? row.roleName.join(', ') : '--' }}
                    </template>
                </el-table-column>
                <el-table-column label="承接问题" prop="acceptorQuestion">
                    <template slot-scope="{ row }">
                        <el-popover
                            placement="top-start"
                            :width="400"
                            trigger="hover"
                            :disabled="!questionOverflow(row.acceptorQuestion)"
                        >
                            <div class="question-popover-body">{{ questionFull(row.acceptorQuestion) }}</div>
                            <span slot="reference" class="question-cell-ref">{{ questionShort(row.acceptorQuestion) }}</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="关注问题" prop="focusOnQuestion">
                    <template slot-scope="{ row }">
                        <el-popover
                            placement="top-start"
                            :width="400"
                            trigger="hover"
                            :disabled="!questionOverflow(row.focusOnQuestion)"
                        >
                            <div class="question-popover-body">{{ questionFull(row.focusOnQuestion) }}</div>
                            <span slot="reference" class="question-cell-ref">{{ questionShort(row.focusOnQuestion) }}</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="电话" prop="phone"></el-table-column>
                <el-table-column label="是否启用" prop="status">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'Disable'">否</span>
                        <span v-if="scope.row.status == 'Enable'">是</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否虚拟账号" prop="virtualAccount">
                    <!-- <template slot-scope="scope">
                        <el-switch disabled v-model="scope.row.virtualAccount" 
                            active-color="#0066ff"
                            inactive-color="#f0f0f5">
                        </el-switch>
                    </template> -->
                    <template slot-scope="scope">
                        <span v-if="scope.row.virtualAccount == true">是</span>
                        <span v-if="scope.row.virtualAccount == false">否</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" prop="created"></el-table-column>

                <el-table-column label="操作" width="140px">
                    <template slot-scope="{row}">
                        <el-button @click="$router.push({name: 'privilege.user.details', query: { id: row.id, userId: row.userId }})" type="text" size="small">信息配置
                        </el-button>
                        <!-- <el-button @click="deleteRow([row.userId])" type="text" size="small" style="color: #f56c6c;">删除</el-button> -->
                    </template>
                </el-table-column>
            </template>
        </m-table-list>
    </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";

export default {
    name: "privilege.menu.list",
    data() {
        return {
            filters: {
                account: "",
                userName: "",
                roleName: "",
                id: "",
                phone: "",
                email: "",
                status: "",
            },
            time: "",
            roleOptions: [],
            syncIng: false,
        };
    },
    components: {
        "m-table-list": tableList,
    },
    activated() {
        this.getRoleInfoListCut();
    },
    deactivated() {
        this.roleOptions = [];
    },
    methods: {
        fetchListFunc: api.manage.getUserList,
        handleSearch() {
            this.$refs.tableList.handleSearch();
        },
        handleSync() {
            this.syncIng = true;
            api.manage
                .syncUserInfo()
                .then((res) => {
                    this.syncIng = false;
                    if (res.data.success) {
                        this.$message({
                            message: "同步成功",
                            type: "success",
                            duration: 1000,
                        });
                    } else {
                        this.$message({
                            message: "同步失败",
                            type: "error",
                            duration: 1000,
                        });
                    }
                })
                .catch(() => {
                    this.syncIng = false;
                });
        },
        handleClearSearchForm() {
            this.$refs.tableList.resetSearchForm();
        },
        getRoleInfoListCut() {
            api.manage.getAllUserList().then((res) => {
                this.roleOptions = res.data.data;
            });
        },
        handleChange(val) {},
        deleteRow(id) {
            this.$confirm("是否删除", "提示", {
                confirmButtonText: "确定",
                confirmButtonClass: "confirmBtn",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                api.manage.deleteUser({ userId: id }).then(() => {
                    this.$message.success("删除成功");
                    this.$refs.tableList.getMainData();
                });
            });
        },
        handleUserStatusChange(status, row, index) {
            api.manage.updateUserStatus({ userId: row.userId }).then((res) => {
                this.$message.success("提交成功");
                this.$refs.tableList.setRowValue(index, { status });
            });
        },
        questionShort(val) {
            if (val == null || val === "") return "--";
            return val.length > 50 ? val.slice(0, 50) + "…" : val;
        },
        questionOverflow(val) {
            if (val == null || val === "") return false;
            return val.length > 50;
        },
        questionFull(val) {
            return val == null ? "" : val;
        },
    },
};
</script>

<style scoped>
.question-cell-ref {
    word-break: break-all;
}

.question-popover-body {
    line-height: 1.5;
    word-break: break-word;
}
</style>
